import ManageColumnsField from './ManageColumnsField.component';

export default ManageColumnsField;
